import React, { useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
// core components
import { MemoizedSideBar } from "components/Sidebar/Sidebar";
import AdminNavbar from "components/Navbars/AdminNavbar";
import { routes } from "routes";
import { getMenuArray, getMenuPermisoMap, puedeAccederPorPermiso } from "utils";
import { Unauthorized } from "views";
import { useConfigurationPage } from "hooks/useConfigurationPage";
import { useAuthentication } from "hooks";

function AdminLayout({ rutasMenu, logo, codigo = "" }) {
  const [menus, setMenus] = useState([]);
  const { setConfigurationState } = useConfigurationPage();
  const { usuario } = useAuthentication();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname != "/EntidadesList") {
      setConfigurationState(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (usuario) setRouteComponentForMenu();
  }, [usuario]);

  function setRouteComponentForMenu() {
    let rutasMenu = getMenuArray();

    const Permisos = usuario?.Funciones;
    if (rutasMenu?.length > 0) {
      rutasMenu = rutasMenu.filter((menu) =>
        puedeAccederPorPermiso(Permisos, menu.PermisoNombre)
      );
    } else {
      rutasMenu = [];
    }
    setMenus(rutasMenu);
  }

  // Route guard: a page mapped to a menu permission is only rendered when the user
  // holds that permission (same predicate that shows/hides its menu link). Otherwise
  // the Unauthorized view is shown, preventing forced browsing to hidden pages.
  // Routes with no menu-permission mapping pass through unchanged.
  const permisoMap = getMenuPermisoMap();
  const rutasProtegidas = usuario
    ? routes.map((route) => {
        const path = route.props?.path;
        const permisoNombre = permisoMap[path];
        if (
          permisoNombre &&
          !puedeAccederPorPermiso(usuario?.Funciones, permisoNombre)
        ) {
          return (
            <Route
              key={route.key}
              exact={route.props.exact}
              path={path}
              render={() => <Unauthorized />}
            />
          );
        }
        return route;
      })
    : routes;

  return (
    <>
      <div className="wrapper">
        <MemoizedSideBar
          routes={menus}
          isFixed={true}
          logo={logo}
          codigo={codigo}
        />
        <div className="main-panel">
          <AdminNavbar />
          <div className="content">
            <Switch>{rutasProtegidas}</Switch>
          </div>
        </div>
      </div>
    </>
  );
}
export const MemoizedAdminLayout = React.memo(AdminLayout);
